import DefaultTheme from './default'

export type ThemeType = typeof DefaultTheme

export { DefaultTheme }
